<template>
    <div class="content" style="background-color: #fff;height: auto;">
    	<div class="recharge_head">
    		<p style="margin:.4rem;">
    			<span>账号：<font v-text="organizationInfo.organizationName"></font></span>
    			<van-popup v-model="show" position="bottom" round>
    				<p v-for="item in actions" class="recharge4" @click="organizationInfo=item;show=false;">
    					<span v-text="item.organizationName"></span>
    				</p>
    			</van-popup>
    		</p>
    		<p style="margin: .3rem .4rem;">智能电话</p>
    		<p>
    			<span style="color: #fff;font-size: .28rem;">
    				<font v-if="organizationInfo.appLevel==0">未开通</font>
					<font v-if="organizationInfo.appLevel!=0">到期时间：{{organizationInfo.appExpireTime}}</font>
    			</span>
    		</p>
    	</div>
    	<div class="recharge_body">
    		<div style="overflow: hidden;">
    			<strong class="recharge1">充值</strong>
    			<span  @click="$router.push('/rechargeList')" style="color: #9B9EA3;font-size: .26rem;float: right;line-height: .42rem;text-decoration:underline;">查看充值记录</span>
    		</div>
    		<div class="recharge_input">
				<label>￥</label>
				<input type="number" name="money" min="1" v-model="money" readonly="readonly">
				<!-- <img src="../../assets/images/inputclear.png" @click="money='';active=0;"> -->
    		</div>
    		<div class="recharge2">
    			<span :class="active==1?'active':''" @click="money='299';day=360;active=1;" style="width: auto;padding: 0 .2rem;">299元/年/人</span>
    			<span :class="active==2?'active':''" @click="money='999';day=360;active=2;" style="width: auto;padding: 0 .2rem;">999元/年/不限人数</span>
    			<!-- <span :class="active==3?'active':''" @click="money='2997';day=1080;active=3;">三年</span> -->
    		</div>
    		<a href="javascript:void(0)" class="recharge3" @click="getPayParm">确认充值</a>
    		<!-- <a href="javascript:void(0)" class="recharge3" @click="succees=true">确认充值</a> -->
    	</div>
    	<!-- <van-popup v-model="succees" position="top" style="width: 100%;height: 100%;">
			<div style="padding: 0 .4rem;text-align: center;">
				<p><img src="../../assets/images/124.png" style="width: 2.84rem;display: block;margin: .66rem auto .46rem auto;"></p>
				<p style="font-size: .38rem;margin: .2rem 0 .6rem 0;"><strong>支付成功</strong></p>
				<p style="font-size: .32rem;color: #777777;margin: .2rem 0;">本次充值金额  <font color="#FF8400" v-text="money"></font>元</p>
				<p style="font-size: .32rem;color: #777777;margin: .2rem 0;">当前账户余额  <font>{{(organizationInfo.accountBalance+money*100)/100}}</font>元</p>
				<a href="javascript:void(0)" class="recharge3" @click="succees_ck" style="margin-top: .6rem;">确认</a>
			</div>
		</van-popup> -->
    </div>
</template>
<script>
	// require('@/wx.js');
	import axios from 'axios';
    import {toPayByJSapi,getOrganizationDetail} from '../../api';
    export default {
        name: 'recharge',
        data() {
            return {
                organizationInfo:{
                	accountBalance:0
                },
				openId:"",
				money:299,
				day:360,
				active:1,
				show:false,
				actions: [],
				succees:false
            }
        },
        methods: {
            getQueryString(name) {
				var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i"); 
				var r = window.location.search.substr(1).match(reg); 
				if (r != null) return decodeURI(r[2]); return ""; 
			},
			succees_ck(){
				this.succees = false;
				this.money = "";
				this.getOrganizationDetail();
			},
            getOrganizationDetail(){
            	getOrganizationDetail().then((res) => {
                    if(res.code==1){
                        this.organizationInfo = res.data;
                    }else{
                        this.$toast("错误信息:"+res.message);
                    }
                });
            },
            getPayParm(){
            	var that = this;
            	var money = parseInt(that.money*100)/100;
            	that.money = money.toFixed(2);
            	if(that.money==""||that.money=="0"){
            		that.$toast("请充值大于1元的金额！")
            		return;
            	}
            	toPayByJSapi({
            		aiCount:0,
            		day:that.day,
            		money:that.money*100,
            		organizationId:that.organizationInfo.id,
            		payPurpose:9,
            		payType:1,
            		openId:that.openId
            	}).then(function(res) {
                    if (res.code==1) {
                        that.wxConfig = res.data;
                        that.initwxserver();
                    }else{
                        that.$toast(res.message)
                    }
				})
            },
            initwxserver(){
            	var that = this;
            	if (typeof WeixinJSBridge == "undefined"){  
		            if( document.addEventListener ){  
		                document.addEventListener('WeixinJSBridgeReady', bridgePay, false);  
		            }else if (document.attachEvent){  
		                document.attachEvent('WeixinJSBridgeReady', bridgePay);   
		                document.attachEvent('onWeixinJSBridgeReady', bridgePay);  
		            }  
		        }else{
		            that.bridgePay('getBrandWCPayRequest');
		        }
            },
            bridgePay(serverName){
            	var that = this;
            	WeixinJSBridge.invoke(serverName, {
			        "appId": that.wxConfig.appId,
			        //公众号名称，由商户传入     
			        "timeStamp": that.wxConfig.timeStamp,
			        //时间戳，自1970年以来的秒数     
			        "nonceStr": that.wxConfig.nonceStr,
			        //随机串     
			        "package": that.wxConfig.package,
			        "signType": that.wxConfig.signType,
			        //微信签名方式：     
			        "paySign": that.wxConfig.paySign //微信签名 
			    },function(res) {
			        if(res.err_msg == "get_brand_wcpay_request:ok" ){
	                	// 使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
	                	that.succees=true;
	                	that.succees_ck();
	                	that.$toast('支付成功!')
	                }
			    });
            }
        },
        mounted(){
        	this.openId = sessionStorage.getItem('openId');
            this.getOrganizationDetail();
    	}
	}
</script>
<style type="text/css">
	.recharge_head {
		width: 100%;
		height: 3.6rem;
		background-image: url(../../assets/images/123.png);
		background-size: 6.7rem 2.8rem;
		background-repeat: no-repeat;
		background-position: center;
		padding: .4rem;
		font-size: .28rem;
		line-height: .28rem;
		color: #fff;
	}
	.recharge_head p {
		margin: .15rem .4rem;
	}
	.recharge_body {
		padding: .1rem.4rem;
	}
	.recharge1 {
		color: #777777;
		font-size: .32rem;
	}
	.recharge_input {
		width: 100%;
		height: 1.16rem;
		border-bottom: 1px solid #dedede;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		color: #222222;
	}
	.recharge_input label {
		font-weight: bold;
		font-size: .52rem;
		width: .6rem;
	}
	.recharge_input input {
		font-weight: bold;
		font-size: .48rem;
		border:none;
		margin: 0 .15rem;
		width: calc(100% - .6rem - .46rem - .3rem);
	}
	.recharge_input img {
		width: .46rem;
		height: .46rem;
	}
	.recharge2 {
		padding: .4rem 0;
		overflow: hidden;
	}
	.recharge2 span {
		width: 2rem;
		height: 1rem;
		display: block;
		float: left;
		margin: .1rem .1rem;
		line-height: 1rem;
		text-align: center;
		color: #222222;
		font-size: .32rem;
		font-weight: bold;
		border:2px solid rgba(237,237,237,1);
		box-shadow:0px 0px 24px 0px rgba(0, 0, 0, 0.08);
		border-radius: .12rem;
		background-color: #fff;
	}
	.recharge2 span.active {
		border:2px solid rgba(59,137,255,1);
		box-shadow:0px 0px 24px 0px rgba(10,65,148,0.17);
		color: #3B89FF;
		background-color: rgba(10,65,148,0.05);
	}
	.recharge3 {
		/*position: absolute;
		height: .88rem;
		left: .3rem;
		right: .3rem;
		bottom: .25rem;*/
		background-color: #3B89FF;
		font-size: .32rem;
		color: #fff;
		text-align: center;
		line-height: .88rem;
		border-radius: .06rem;
		height: .88rem;
		width: 100%;
		display: block;
		margin: 2.4rem auto .25rem auto;
	}
	p.recharge4 {
		color: #000;
		/*padding: .1rem;*/
		text-align: center;
		border-top: 1px solid #dedede;
		height: 1rem;
		line-height: 1rem;
		margin: 0;
		display: block;
		font-size: .32rem;
	}
</style>


// WEBPACK FOOTER //
// src/views/order/rechargeConversation.vue


// WEBPACK FOOTER //
// src/views/order/rechargeConversation.vue